import { useEffect, useState } from "react";
import translateText, {
  LanguageDirection,
  currentLanguage,
} from "../signals/language.signal";
import { fetchCatalogData } from "../signals/catalogData.signal";
import { primaryFount } from "../signals/Theme colors.signal";
import LazyImage from "./LazyImage";
import { getCurrencySymbol } from "./CurrencySymbol";

const CatalogBox = ({ catano }) => {
  const [catalogData, setCatalogData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchCatalogData(catano);
        setCatalogData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [catano]);

  return (
    <>
      {catalogData ? (
        catalogData.map((element) => (
          <div
            key={element.ARTCODE}
            className="col-12 col-lg-3"
            dir={LanguageDirection.value}
            style={{ fontWeight: 700 }}
          >
            <div className="mb-3 position-relative loginContaner bg-white shadow rounded-3 d-flex justify-content-between align-items-center">
              <div
                className="border w-100 rounded-3 bg-secondary-subtle"
                style={{ height: "180px" }}
              >
                <LazyImage
                  src={element.IMGURL}
                  alt={element.COLLECTIONENAME}
                  height="180px"
                  width="100%"
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                  className="p-0 rounded-3"
                />
              </div>
              <div
                className="w-100 mt-3 p-2 position-absolute bottom-0 text-white"
                style={{ filter: "drop-shadow(2px 4px 6px black)" }}
              >
                <div className="mb-1 w-100 rounded-3">
                  <p
                    className="form-label m-0"
                    style={{ fontSize: 12, fontWeight: "700" }}
                  >
                    {element.COLLECTIONANAME}
                  </p>
                </div>
                <table cellPadding={0} cellSpacing={0} className="tayble w-100">
                  <tbody>
                    <tr>
                      <td valign="top" className="p-0">
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: "700",
                          }}
                        >
                          {translateText(currentLanguage.value, "ProductCode")}
                        </div>
                      </td>
                      <td className="p-0">
                        <div
                          className={
                            LanguageDirection.value === "rtl"
                              ? "text-start"
                              : "text-end"
                          }
                          style={{ fontSize: 12 }}
                        >
                          {element.ARTCODE}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top" className="p-0">
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: "700",
                          }}
                        >
                          {translateText(currentLanguage.value, "Price")}
                        </div>
                      </td>
                      <td className="p-0">
                        <div
                          className={
                            LanguageDirection.value === "rtl"
                              ? "text-start"
                              : "text-end"
                          }
                          dir="ltr"
                          style={{ fontSize: 12 }}
                        >
                          {getCurrencySymbol('#fff','14px','12px')}
                          {element.PRICE}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top" className="p-0">
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: "700",
                          }}
                        >
                          {translateText(currentLanguage.value, "Composition")}
                        </div>
                      </td>
                      <td className="p-0">
                        <div
                          className={
                            LanguageDirection.value === "rtl"
                              ? "text-start"
                              : "text-end"
                          }
                          style={{ fontSize: 12 }}
                        >
                          {element.COMPOSITION || "N/A"}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top" className="p-0">
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: "700",
                          }}
                        >
                          {translateText(currentLanguage.value, "Width")}
                        </div>
                      </td>
                      <td className="p-0">
                        <div
                          className={
                            LanguageDirection.value === "rtl"
                              ? "text-start"
                              : "text-end"
                          }
                          style={{ fontSize: 12 }}
                        >
                          {element.WIDTH} cm
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="d-flex justify-content-center flex-column align-items-center h-100">
          <h5>{translateText(currentLanguage.value, "Loading")}</h5>
        </div>
      )}
    </>
  );
};

export default CatalogBox;
